var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { SvgIconContext } from "./SvgIconContext";
import * as style from "./SvgIcon.module.css";
const SvgIcon = _a => {
  var _b = _a,
    {
      src,
      alt = "",
      className
    } = _b,
    props = __objRest(_b, ["src", "alt", "className"]);
  const [previousSrc, setPreviousSrc] = useState(src);
  const [previousAlt, setPreviousAlt] = useState(alt);
  const [svg, setSvg] = useState("");
  const {
    icons,
    fetchIcon
  } = useContext(SvgIconContext);
  useEffect(() => {
    var _a2;
    if (!svg.trim() || src !== previousSrc || alt !== previousAlt) {
      const altText = !(alt == null ? void 0 : alt.trim()) ? "noalt" : alt;
      const icon = icons.find(icon2 => icon2.src === src && icon2.alt === altText);
      setSvg((_a2 = icon == null ? void 0 : icon.icon) != null ? _a2 : fetchIcon(src, altText));
      setPreviousSrc(src);
      setPreviousAlt(altText);
    }
  });
  return /* @__PURE__ */jsx("div", __spreadValues({
    className: classNames(style.icon, className),
    dangerouslySetInnerHTML: {
      __html: svg
    }
  }, props));
};
export default SvgIcon;